import axios from 'src/utils/axios';

export const GET_TOTAL_BOTS = '@bots/get-total-bots';
export const GET_BOTS = '@bots/get-bots';
export const GET_BOT = '@bots/get-bot';
export const ADD_BOT = '@bots/add-bots';
export const DELETE_BOTS = '@bots/delete-bots';
export const UPDATE_BOT = '@bots/update-bots';
export const SHOW_BOT_ACTIONS = '@bots/show-bots-actions';
export const HIDE_BOT_ACTIONS = '@bots/hide-bots-actions';

export function updateBotsByWorkspace(botIds, workspaceId) {
  const request = axios.put(`/api/bots/updateBotsToWorkspace`, {
    botIds,
    workspaceId
  });
  return dispatch => {
    console.log(`Update to ${workspaceId}: ${JSON.parse(botIds).join(', ')}`);
    request.then(response => dispatch(getBots(workspaceId)));
  };
}

export function getTotalBots() {
  const request = axios.get('/api/bots/all');
  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_TOTAL_BOTS,
        payload: response.data
      })
    );
  };
}

export function getBots(workspaceId) {
  const request = axios.post('/api/bots/all', { workspaceId });
  return dispatch => {
    request.then(response =>
      dispatch({
        type: GET_BOTS,
        payload: response.data
      })
    );
  };
}

export function getBot(botId) {
  const request = axios.get(`/api/bots/${botId}`);

  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_BOT,
        payload: response.data
      })
    );
  };
}

export function addBot(bot, workspaceId) {
  const request = axios.post('/api/bots/add', { bot, workspaceId });

  return dispatch => {
    request.then(response =>
      dispatch({
        type: ADD_BOT,
        payload: response.data
      })
    );
  };
}

export function deleteBots(id) {
  const request = axios.delete(`/api/bots/delete/${id}`);
  return dispatch => {
    request.then(() =>
      dispatch({
        type: DELETE_BOTS,
        payload: { id }
      })
    );
  };
}

export function updateBot(bot) {
  const request = axios.put('/api/bots/update', { bot });
  return dispatch => {
    request.then(response => {
      dispatch({
        type: UPDATE_BOT,
        payload: response.data
      });
    });
  };
}

export function checkAndUpdateBot(bot) {
  const checkRequest = axios.post('/api/bots/check', { bot });

  return dispatch => {
    checkRequest.then(checkResponse => {
      const enabled = checkResponse.data.status;
      let nlu_config = bot.nlu_config;
      if (typeof bot.nlu_config === 'string') {
        nlu_config = JSON.parse(bot.nlu_config);
      }
      const newBot = { ...bot, nlu_config: { ...nlu_config, enabled } };
      const putRequest = axios.put('/api/bots/update', { bot: newBot });
      putRequest.then(response => {
        dispatch({
          type: UPDATE_BOT,
          payload: response.data
        });
      });
    });
  };
}

export function restartBot(botId) {
  const request = axios.get(`/api/server/restart/${botId}`);
  request.then(console.log(`[${botId}] restarting bot`));
}
